var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2383 1.81641L10.1836 0.761719L6 4.94531L1.81641 0.761719L0.761719 1.81641L4.94531 6L0.761719 10.1836L1.81641 11.2383L6 7.05469L10.1836 11.2383L11.2383 10.1836L7.05469 6L11.2383 1.81641Z",
    fill: "#8083A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXclose);
export default __webpack_public_path__ + "static/media/xclose.cff86e49.svg";
export { ForwardRef as ReactComponent };